import { Currency } from "@redotech/money/currencies";
import * as z from "zod/v4";

export const addOutboundFunds = {
  name: "addOutboundFunds" as const,
  input: z.object({
    amount: z.number(),
    alertThreshold: z.number(),
    currency: z.enum(Currency),
    paymentMethodId: z.string(),
  }),
  output: z.object({ balance: z.string() }),
};
